export const PIANO_SOUND_DEFAULT = 'default'
export const PIANO_SOUND_HEADROOM_FULL = 'headroom-c3-close-full'
export const PIANO_SOUND_HEADROOM_INTIMATE = 'headroom-c3-intimate'
export const PIANO_SOUND_SPLENDID_STEINWAY = 'splendid-steinway'

// Historical code imports this name for the preferred sampled piano.
export const PIANO_SOUND_STUDIO_GRAND = PIANO_SOUND_HEADROOM_INTIMATE

export const PIANO_SOUND_OPTIONS = Object.freeze([
    {value: PIANO_SOUND_DEFAULT, label: 'Default'},
    {value: PIANO_SOUND_HEADROOM_INTIMATE, label: 'Closest target — Headroom C3 intimate / 9.5 MiB'},
    {value: PIANO_SOUND_HEADROOM_FULL, label: 'Headroom Yamaha C3 — close mic / 5 layers / 68.2 MiB'},
    {value: PIANO_SOUND_SPLENDID_STEINWAY, label: 'Splendid Steinway — public-domain FLAC / 73.4 MiB'},
])

const createProfile = (id, sampleCount) => Object.freeze({
    id,
    engine: 'sample-bank',
    bankId: id,
    sampleCount,
})

export const STUDIO_GRAND_PROFILES = Object.freeze({
    [PIANO_SOUND_HEADROOM_INTIMATE]: createProfile(PIANO_SOUND_HEADROOM_INTIMATE, 30),
    [PIANO_SOUND_HEADROOM_FULL]: createProfile(PIANO_SOUND_HEADROOM_FULL, 150),
    [PIANO_SOUND_SPLENDID_STEINWAY]: createProfile(PIANO_SOUND_SPLENDID_STEINWAY, 226),
})

// Removed comparison-bank values remain as migration aliases for saved settings.
const LEGACY_PROFILE_ALIASES = Object.freeze({
    'studio-grand': PIANO_SOUND_HEADROOM_INTIMATE,
    'studio-grand-soft': PIANO_SOUND_HEADROOM_INTIMATE,
    'studio-grand-dry': PIANO_SOUND_HEADROOM_FULL,
    'studio-grand-resonant': PIANO_SOUND_HEADROOM_FULL,
    'studio-grand-120': PIANO_SOUND_HEADROOM_FULL,
    'studio-grand-180': PIANO_SOUND_HEADROOM_FULL,
    'studio-grand-240': PIANO_SOUND_HEADROOM_FULL,
    'studio-grand-full': PIANO_SOUND_HEADROOM_FULL,
    'studio-grand-full-sfz': PIANO_SOUND_HEADROOM_FULL,
    'tone-salamander-full': PIANO_SOUND_HEADROOM_FULL,
    'salamander-v3-wav16-dry': PIANO_SOUND_HEADROOM_FULL,
    'salamander-v3-wav16-complete': PIANO_SOUND_HEADROOM_FULL,
    'salamander-v3-wav24-dry': PIANO_SOUND_HEADROOM_FULL,
    'salamander-v3-wav24-complete': PIANO_SOUND_HEADROOM_FULL,
    'salamander-v3-flac24-dry': PIANO_SOUND_HEADROOM_FULL,
    'salamander-v3-flac24-complete': PIANO_SOUND_HEADROOM_FULL,
    'vcsl-grand-k': PIANO_SOUND_HEADROOM_INTIMATE,
    'vcsl-grand-s-1895': PIANO_SOUND_HEADROOM_INTIMATE,
})

export const normalizePianoSound = (value) => {
    const normalizedValue = LEGACY_PROFILE_ALIASES[value] ?? value
    return Object.hasOwn(STUDIO_GRAND_PROFILES, normalizedValue)
        ? normalizedValue
        : PIANO_SOUND_DEFAULT
}

export const isStudioGrandSound = (value) =>
    normalizePianoSound(value) !== PIANO_SOUND_DEFAULT

export const resolveStudioGrandProfile = (value) =>
    STUDIO_GRAND_PROFILES[normalizePianoSound(value)]
    ?? STUDIO_GRAND_PROFILES[PIANO_SOUND_STUDIO_GRAND]
